import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import { AgentSchedulerProvider } from 'Context/NewAgentSchedulerContext';
import { withHouseholdContextAdapter } from 'Context/SimpleHouseholdContext';
import SchedulerModalHeader from './SchedulerModalHeader';
import ViewContainer from './ViewContainer';


const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
});

const Scheduler = ({
  className,
  classes,
}) => {
  const { rootNodeProps } = useEventTrackingLogEvent({
    nodeName: 'MC Scheduler',
    isPageView: true,
  });

  return (
    <AgentSchedulerProvider>
      <div
        {...rootNodeProps}
        test="scheduler-modal"
        className={classNames(className, classes.root)}
      >
        <SchedulerModalHeader />
        <ViewContainer />
      </div>
    </AgentSchedulerProvider>
  );
};

Scheduler.defaultProps = {
  className: '',
};

Scheduler.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withHouseholdContextAdapter(withStyles(styles)(Scheduler));
